export const sidebars = {
	document: 'edit-post/document',
	block: 'edit-post/block',
};
